import React, { useState, useEffect } from 'react';
import cartService from '../../services/cart.service';
import './CartButton.css';

interface CartButtonProps {
  onClick: () => void;
}

const CartButton: React.FC<CartButtonProps> = ({ onClick }) => {
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    // Get initial cart count
    setCartCount(cartService.getCartCount());

    // Listen for cart updates
    const handleCartUpdate = () => {
      setCartCount(cartService.getCartCount());
    };

    window.addEventListener('cart-updated', handleCartUpdate);

    return () => {
      window.removeEventListener('cart-updated', handleCartUpdate);
    };
  }, []);

  if (cartCount === 0) return null;

  return (
    <button className="cart-button" onClick={onClick}>
      <span className="cart-button-text">Giỏ hàng</span>
      <span className="cart-button-badge">{cartCount}</span>
    </button>
  );
};

export default CartButton;


